import { render } from "./DialogApprovals.vue?vue&type=template&id=975be9da&scoped=true"
import script from "./DialogApprovals.vue?vue&type=script&lang=js"
export * from "./DialogApprovals.vue?vue&type=script&lang=js"

import "./DialogApprovals.vue?vue&type=style&index=0&id=975be9da&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-975be9da"]])

export default __exports__